export * from './component';



// WEBPACK FOOTER //
// ./src/components/treatment-services/map/index.js